import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useCallback } from 'react';
var KV_REST_API_URL = process.env.NEXT_PUBLIC_KV_REST_API_URL;
var KV_REST_API_TOKEN = process.env.NEXT_PUBLIC_KV_REST_API_TOKEN;
export function useKv() {
  var setKV = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var key, value, type, d;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              key = _ref.key, value = _ref.value, type = _ref.type;
              _context.prev = 1;
              _context.next = 4;
              return fetch("".concat(KV_REST_API_URL, "/set/").concat(key), {
                headers: {
                  Authorization: "Bearer ".concat(KV_REST_API_TOKEN)
                },
                body: JSON.stringify({
                  value: value,
                  type: type
                }),
                method: 'POST'
              }).then(function (response) {
                return response.json();
              }).then(function (data) {
                return data;
              });

            case 4:
              d = _context.sent;
              return _context.abrupt("return", d);

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              console.error("Error setting data", _context.t0);
              return _context.abrupt("return", null);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), []);
  var getKV = useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(key) {
      var value;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (key) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return", {
                value: '',
                param: key
              });

            case 2:
              _context2.prev = 2;
              _context2.next = 5;
              return fetch("".concat(KV_REST_API_URL, "/get/").concat(key), {
                headers: {
                  Authorization: "Bearer ".concat(KV_REST_API_TOKEN)
                }
              }).then(function (response) {
                return response.json();
              }).then(function (data) {
                return JSON.parse(data.result);
              });

            case 5:
              value = _context2.sent;
              return _context2.abrupt("return", _objectSpread(_objectSpread({}, value), {}, {
                param: key
              }));

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](2);
              console.error("error getting value", {
                error: _context2.t0,
                key: key
              });
              return _context2.abrupt("return", null);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 9]]);
    }));

    return function (_x2) {
      return _ref3.apply(this, arguments);
    };
  }(), []);
  return {
    setKV: setKV,
    getKV: getKV
  };
}